const parse = (module, payload, type = "patch") => {
    let cloned_payload = JSON.parse(JSON.stringify(payload));

    // if created_at is not set, then set it to current time, always set updated_at to current time
    if (!cloned_payload.created_at) {
        cloned_payload.created_at = new Date().toISOString();
    }

    // if db is not synced, then set not_synced to true
    if (type === "post") {
        cloned_payload.not_synced = true;
    }

    cloned_payload.updated_at = new Date().toISOString();

    switch (module) {
        case "measurements":
            // if classification is not fully filled, then it is not a defect
            if (
                (!cloned_payload.error_indication_id ||
                    !cloned_payload.error_classification_id ||
                    !cloned_payload.repair_period_id ||
                    !cloned_payload.danger_aspect_id) &&
                cloned_payload.is_defect
            ) {
                cloned_payload.is_defect = false;
            }

            // if classification is fully filled, then it is a defect
            if (
                cloned_payload.error_indication_id &&
                cloned_payload.error_classification_id &&
                cloned_payload.repair_period_id &&
                cloned_payload.danger_aspect_id &&
                !cloned_payload.is_defect
            ) {
                cloned_payload.is_defect = true;
            }

            // remove measurement.rules.field.rules per field
            if (cloned_payload.rules && cloned_payload.rules.fields) {
                cloned_payload.rules.fields.forEach((field) => {
                    if (field.rules) {
                        field.rules = null;
                    }
                });
            }

            // if !completed
            if (!cloned_payload.completed) {
                cloned_payload.completed = false;
            }

            break;

        default:
            break;
    }

    return cloned_payload;
};

export default parse;
